import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 42);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="bg-red-600 text-white text-center py-3 px-4 font-bold text-sm md:text-lg sticky top-0 z-50 shadow-lg flex flex-col md:flex-row justify-center items-center gap-1 md:gap-3 font-montserrat uppercase tracking-wide border-b-4 border-red-800" data-id="element-421">
      <span data-id="element-422">
        ⏰ OFERTA EXPIRA EN: {String(minutes).padStart(2, '0')}:
        {String(seconds).padStart(2, '0')}
      </span>
      <span className="hidden md:inline text-red-300" data-id="element-423">|</span>
      <span className="text-yellow-300" data-id="element-424">SOLO QUEDAN 5 CUPOS</span>
    </div>;
}